import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
    Box,
    Chip as MuiChip,
    Divider as MuiDivider,
    Grid,
    IconButton,
    Paper as MuiPaper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    Toolbar,
    Tooltip,
    Typography,
    CircularProgress,
} from "@material-ui/core";

import { green, orange, red } from "@material-ui/core/colors";
import {
    RemoveRedEye as RemoveRedEyeIcon,
    Delete as DeleteIcon,
    Edit as EditIcon,
} from "@material-ui/icons";
import { spacing } from "@material-ui/system";
import {
    HighlightProduct,
    getProducts,
} from "../NetworkCalls/Products/ServerReq";
import ButtonIconComponent from "../Components/ButtonIcons";
import SearchBar from "../Components/SearchBar";
import { ExportToExcel } from "../Components/ExportToExcel";
import ImportExcel from "../Components/ImportExcel";
import FilterBox from "../Components/filterBox";
import { GetAllData } from "../NetworkCalls/Admin/ServerReq";
const Divider = styled(MuiDivider)(spacing);
const Paper = styled(MuiPaper)(spacing);
const Chip = styled(MuiChip)`
	${spacing};
	background: ${(props) => props.shipped && green[500]};
	background: ${(props) => props.processing && orange[700]};
	background: ${(props) => props.cancelled && red[500]};
	color: #fff;
`;

const Spacer = styled.div`
	flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
	min-width: 150px;
`;

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: "id", alignment: "left", label: "S.No" },
    { id: "businessName", alignment: "left", label: "Restaurant Name" },
    { id: "shortAddress", alignment: "left", label: "Street Address" },
    { id: "status", alignment: "left", label: "Status" },
    { id: "happyhours", alignment: "left", label: "Happy Hours" },
    { id: "kidsmenu", alignment: "left", label: "Kids Menu" },
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.alignment}
                        padding={headCell.disablePadding ? "none" : "default"}
                        sortDirection={orderBy === headCell.id ? order : false}>
                        <Box>
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                onClick={createSortHandler(headCell.id)}
                                style={{ color: "#969696", fontWeight: 600 }}>
                                {headCell.label}
                            </TableSortLabel>
                        </Box>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

let EnhancedTableToolbar = (props) => {
    const {   setData,   fixedData } = props;
    const [searched, setSearched] = React.useState("");

    return (

        <div
            style={{
                display: "flex",
                // width: "350px",
                alignItems: "center",
                marginLeft: "1rem",
                marginTop: "1rem",
                justifyContent:'flex-end'
            }}>

            <div style={{ width: '30%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FilterBox
                     setData={setData}
                    fixedData={fixedData}
                    
                    filterBy="status"
                    loader={false}
                    options={["General", "Featured"]}
                    name="Filter"
                    onClick={() => console.log("Template")}
                    imageBool={true}
                />
                <SearchBar
                    label="Search"
                    value={searched}
                    onChange={(val) => {
                        setSearched(val);
                        props.onSearch(val);
                    }}
                />
            </div>
        </div>
    );
};

function EnhancedTable({ data, setData }) {
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("customer");
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [loader, setLoader] = React.useState(false);
    const [fixedData, setFixedData] = React.useState([]);
    const [Refresh, setRefresh] = React.useState(false);

    useEffect(() => {

     const getData = async () => {
        try {
            setLoader(true)
            const response = await GetAllData("Restaurants");
                let arr = []
                response.forEach((doc) => {
                    arr.push(doc.data())
                });
               
               
            setData(arr)
            setFixedData(arr)
            setLoader(false)
        } catch (err) {
            
            setLoader(false)

        } finally {     
            setLoader(false);
        }
    };
      
        getData();
        
    }, [Refresh] );

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = data.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    const emptyRows =
        rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    const handleSearch = (val) => {
        console.log(val);
        if (!val) {
            setData(fixedData);
            return;
        }
        const filteredRows = fixedData.filter((row) => {
            return row?.businessName?.toLowerCase().includes(val?.toLowerCase());
        });
       
        setData(filteredRows);
    };
   

    const [open, setOpen] = React.useState(false);

    const [DeleteUid, setDeleteUid] = useState("");
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            {loader ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <Paper
                        style={{
                            boxShadow: "none !important",
                            border: "1px solid rgba(76, 78, 100, 0.25)",
                            borderRadius: "10px",
                        }}>
                        <EnhancedTableToolbar
                            onSearch={(val) => handleSearch(val)}
                            numSelected={selected.length}
                            setData={setData}
                            fixedData={fixedData}
                        />
                        <TableContainer style={{ height: "100%" }}>
                            <Table
                                aria-labelledby='tableTitle'
                                size={"medium"}
                                aria-label='enhanced table'>
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={data.length}
                                />
                                <TableBody>
                                    {stableSort(data, getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            const isItemSelected = isSelected(row.id);
                                            return (
                                                <TableRow
                                                    
                                                    hover
                                                    role='checkbox'
                                                    aria-checked={isItemSelected}
                                                    tabIndex={-1}
                                                    key={`${row.id}-${index}`}
                                                    selected={isItemSelected}>
                                                    <TableCell align='left'>
                                                        <Typography
                                                            style={{ fontWeight: "600", fontSize: "16px" }}>
                                                            {index + 1}.
                                                        </Typography>{" "}
                                                    </TableCell>
                                                    <TableCell align='left'>
                                                        {" "}
                                                        <Typography
                                                            style={{ fontWeight: "600", fontSize: "16px" }}>
                                                            {row?.businessName}
                                                        </Typography>{" "}
                                                    </TableCell>
                                                    <TableCell align='left'>
                                                        {" "}
                                                        <Typography
                                                            style={{ fontWeight: "600", fontSize: "16px" }}>
                                                            {row?.shortAddress}
                                                        </Typography>{" "}
                                                    </TableCell>
                                                    <TableCell align='left'>
                                                        {" "}
                                                        <Typography
                                                            style={{ fontWeight: "600", fontSize: "16px",backgroundColor:'#D9D9D9',color:'#808080',borderRadius:'10px',border: "1px solid #808080",textAlign:'center',padding:'5px 7px' }}>
                                                             {row?.status === undefined ? "General"  : row?.status}
                                                            
                                                        </Typography>{" "}
                                                    </TableCell>
                                                    <TableCell align='left'>


                                                        <Link
                                                            to={{
                                                                pathname:`/dashboard/happy_hours/${row?.id}`,
                                                                state: row,
                                                            }}>
                                                            <Tooltip title='Happy Hours'>
                                                                <IconButton>
                                                                    <img src="/assets/uil_smile.svg" alt="logo" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Link>


                                                    </TableCell>

                                                    <TableCell padding='none' align='left'>
                                                        <Box mr={2} style={{
                                                            display: "flex",
                                                            justifyContent: "start",
                                                            alignItems: "center",
                                                            gap: "10px",

                                                        }}>

                                                            <Link
                                                                to={{
                                                                    pathname: `/dashboard/kids_menu/${row?.id}`,
                                                                    state: row,
                                                                }}>
                                                                <Tooltip title='Kids Menu'>
                                                                    <IconButton>
                                                                        <img src="/assets/kids_menu.svg" alt="logo" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Link>





                                                        </Box>
                                                    </TableCell>

                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component='div'
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Paper>

                    {/* <DeleteProduct
						open={open}
						data={DeleteUid}
						setData={setData}
						handleOpen={handleOpen}
						setRefresh={setRefresh}
						handleClose={handleClose}
					/> */}
                </>
            )}
        </div>
    );
}

const DailySpecials = () => {
    let [data, setData] = React.useState([]);

    return (
        <React.Fragment>
            {/* <Helmet title="Orders" /> */}

            <Grid
                style={{ marginBottom: "10px", alignItems: "center" }}
                justify='space-between'
                container
                spacing={24}>
                <Grid item>
                    <Typography
                        gutterBottom
                        variant='h3'
                        display='inline'
                        style={{
                            fontWeight: "700",
                            letteSpacing: "0.2px",
                            fontSize: "25px",
                        }}>
                        Daily Specials
                    </Typography>
                </Grid>


            </Grid>

            <Divider
                my={6}
                style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    backgroundColor: "#fafafa",
                }}
            />

            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <EnhancedTable data={data} setData={setData} />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default DailySpecials;
